import modalList from '../../reimburseManage/reimbursement/view/modalList.html'
import rolloutModal from './view/rolloutModal.html'
import exportModal from './view/exportModal.html'
import utils from 'utils'
import angular from 'angular'
import updateMonthModal from './view/updateMonthModal.html'
import managementConfig from './fieldConfig'
class managementListCtrl {
    constructor($scope, $uibModal, httpRequest, sweetalert, logger, initSortService, exportSettingService, getOvatAmtService) {
        $scope.currentOrgId = JSON.parse(localStorage.user_info).user.currentOrgId
        const currentRoutAddress = JSON.parse(sessionStorage.getItem('currentRoutAddress'))
        const startDate = new Date()
        startDate.setFullYear(startDate.getFullYear() - 1)
        $scope.datePickerConfig = {
            // startDate,
            // endDate: new Date(),
            minView: 'year', //只能选择月份
            startView: 'year',
            format: 'yyyymm',
            clearBtn: true, //清除按钮
        }
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量收票',
                    // hasPermit: 'receive_invoice', 权限放开不做单独机构控制
                    handler() {
                        $scope.receive()
                    },
                },
                {
                    text: '批量回退',
                    // hasPermit: 'collection_regression',
                    handler() {
                        $scope.backInvoice()
                    },
                },
                {
                    text: '批量转出',
                    // hasPermit: 'rollout_management',
                    handler() {
                        $scope.rollOut()
                    },
                },
                {
                    text: '取消收票',
                    // hasPermit: 'receive_invoice',
                    handler() {
                        $scope.cancelReceive()
                    },
                },
                {
                    text: '取消转出',
                    hasPermit: 'cancel_rollout',
                    handler() {
                        $scope.cancelRollOut()
                    },
                },
                {
                    text: '批量下载',
                    handler() {
                        $scope.batchDownload()
                    },
                },
            ],
        }
        $scope.batchDownload = function () {
            if (!$scope.selectedRows.length) return logger.logError('请选择要下载影像的数据行')
            const errorList = $scope.selectedRows.filter((i) => {
                return !i.imageKey
            })
            if (errorList && errorList.length && $scope.billType != 1 && $scope.billType != 10 && $scope.billType != 11) return logger.logError('存在不能下载影像的数据行')
            const params = {
                invoiceIdList: $scope.selectedRows.map((x) => x.invoiceId).join(','),
            }
            const _url = `${host.etcloudIvatApp}manage/ivatBill/downloadInvoiceBatch?accessToken=${localStorage.getItem('id_token')}`

            utils.post_downLoad(params, _url)
        }
        function get_dictByTypeArr() {
            return httpRequest.get_dictByTypeArr(['ivat_inv_type', 'verify_status', 'deduction_flag', 'expense_usage_status', 'ivat_invoice_status', 'ivat_invoice_source', 'is_received', 'ovat_tax_rate', 'ivat_common_flag', 'proofread_status', 'ivat_bill_source', 'ivat_inv_add_type', 'interface_invoice_status', 'interface_source_system', 'department_no', 'yes_no_flag', 'ivat_comparison_status', 'entry_purpose_status', 'ivat_source_app_id']).then((res) => {
                return res.data.value
            })
        }
        // 对票据种类查询改造 适应树组件
        $scope.billTypeSearch = (billType) => {
            // 默认查询全部票据种类
            let billTypeId = []
            billType.forEach((item) => {
                item.orgName = item.enumName
                item.orgId = item.enumCode
                item.checked = true
                item.open = true
                billTypeId.push(item.enumCode)
            })
            $scope.billTypeList = billType
            $scope.selectedBillTypeList = billType
            $scope.billParamSet[1].invoiceTypeList = billTypeId
        }
        $scope.handleBillTypeChange = (billTypeData) => {
            console.log(billTypeData)
            if (!billTypeData.length) {
                $scope.billTypeSearch($scope.dictData.ivat_inv_add_type)
                $scope.$broadcast('billTypeList', $scope.billTypeList)
                return
            }
            $scope.billParamSet[1].invoiceTypeList = billTypeData.map((item) => {
                return item.orgId
            })
        }
        httpRequest.get_getProjectlistOfCurrentOrg().then((res) => {
            $scope.projectList = res.data.value
        })
        //所属大区
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 获取主管税局省（市）
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // 联动查询出管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                return v.enumName === enumName
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                return v.regionName === enumName
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 获取机构
        //机构树的check配置信息
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
                chkStyle: 'checkbox',
            },
        }
        async function getUserOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                if (res.data.success) {
                    $scope.orgList = res.data.value
                    // 机构勾选变化
                    $scope.orgIdListArr = []
                    // 展开节点及全选
                    angular.forEach($scope.orgList, function (item, index) {
                        item.open = true
                        if ($scope.currentOrgId == item.orgId) {
                            item.checked = true
                            $scope.orgIdListArr.push(item.orgId)
                            // 默认当前操作机构
                            $scope.selectedOrgList = [item]
                        }
                    })
                    $scope.param.param.orgIdList = $scope.orgIdListArr
                    // 默认全部数据
                    //   $scope.selectedOrgList = $scope.orgList;
                    // 返回机构名称
                    $scope.fliterOrgName = function (id) {
                        if (id === null) {
                            return id
                        }
                        if (res.data.value === null) {
                            return id
                        }
                        const fliterUkeyNameArr = res.data.value.filter((item) => item.orgId === id)
                        if (fliterUkeyNameArr.length > 0) {
                            return fliterUkeyNameArr[0].orgName
                        }
                        return id
                    }
                }
                // 需先获取机构参数在查询 异步问题
                get_dictByTypeArr().then((res) => {
                    $scope.dictData = res
                    $scope.billTypeSearch(res.ivat_inv_add_type)
                    $scope.queryTaxInfo()
                })
            })
        }
        // 所选择的机构名称
        $scope.handleOrgChange = function (orgData) {
            //重置
            $scope.orgIdListArr.length = 0
            if (orgData.length > 0) {
                angular.forEach(orgData, function (item, index) {
                    $scope.orgIdListArr.push(item.orgId)
                })
                $scope.param.param.orgIdList = $scope.orgIdListArr
            } else {
                $scope.orgIdListArr = []
                $scope.param.param.orgIdList = $scope.orgIdListArr
            }
        }
        // 是否全选机构
        $scope.orgIsCheckAll = (orgList) => {
            let orgListArr = []
            angular.forEach(orgList, (item, index) => {
                orgListArr.push(item.orgId)
            })
            $scope.param.param.orgIdList = orgListArr
        }
        // 是否全选票据种类
        $scope.billTypeIsCheckAll = (billTypeList) => {
            let billTypeListArr = []
            angular.forEach(billTypeList, (item, index) => {
                billTypeListArr.push(item.orgId)
            })
            if (!billTypeListArr.length) {
                $scope.billTypeSearch($scope.dictData.ivat_inv_add_type)
                $scope.$broadcast('billTypeList', $scope.billTypeList)
                return
            }
            $scope.billParamSet[1].invoiceTypeList = billTypeListArr
        }
        async function getRuleList(ruleType) {
            let result = []
            const res = await httpRequest.get_getIvatRuleConfList({
                ruleType,
            })
            result = res.data.value
            result.forEach((ele) => {
                ele.enumName = ele.ruleName
                ele.enumCode = ele.ruleConfId
            })
            return result
        }
        getRuleList('zclx').then((res) => {
            $scope.ivatRuleList = res
        })
        getRuleList('rzfllx').then((res) => {
            $scope.entryList = res
        })
        $scope.exportSetting = function () {
            exportSettingService('105', $scope.exportConfig)
        }
        $scope.exportConfig = {
            version: 5.51,
            invoiceType: [],
            splitBillFlag: [],
            mainInfo: [
                {
                    label: '票据种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方地址电话',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方银行账号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方地址电话',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方银行账号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '校验码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '收款人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '复核人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '收票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '收票人/时间',
                    selected: true,
                    defaultWord: true,
                },
                // {
                //   label: '抵扣标志',
                //   selected: true,
                //   defaultWord: true,
                // },
                {
                    label: '抵扣属期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '转出属期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '转出类型',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '客运标志',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '业务单据号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '录入方式/人员',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '流程申请人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '管理分区',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '项目名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '项目编号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '入账分类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '进项转出标志',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '进项转出金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '报销状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '关联单据号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '凭证号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '来源系统',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '机构名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '事业部',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '所属大区',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '管理城市',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '主管税局所在省市',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '入账月份',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '账套编码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '录入时间',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '是否修改',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '更新人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '状态比对',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数电票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税局入账用途',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税局入账日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '入账失败原因',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '来源系统编码',
                    selected: true,
                    defaultWord: true,
                },
            ],
            detailInfo: [
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '票据种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方地址电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方开户行及账号',
                    selected: false,
                    defaultWord: false,
                },
            ],
        }
        // 导出字段
        $scope.exportSetting2 = function () {
            $uibModal
                .open({
                    template: exportModal,
                    backdrop: 'static',
                    controller: 'exportModalCtrl',
                    openedClass: 'mod-modal mod-modal-lg mod-modal-big',
                    resolve: {
                        config() {
                            return $scope.exportConfig
                        },
                        invoiceType() {
                            return $scope.profileType
                        },
                        billTypeTitle() {
                            return $scope.billTypeTitle
                        },
                    },
                })
                .result.then((data) => {
                    // 点击确定才更新自定义配置
                    console.log(data.config)
                    // save(data.config)
                })
        }
        $scope.exportCollapsed = false
        $scope.profileTypeObj = {
            version: 5.51,
            queryConfig: managementConfig.queryConfig,
            table: [],
        }
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                createTimeStart: new Date().setDate(1),
                createTimeEnd: new Date(),
            },
        }

        // 票据拆分的初始化
        function initSpilitBillType() {
            $scope.billType = 1 // 初始为增值税发票
            $scope.profileType = '107' // 发票管理tab
            $scope.ifFlodBillTypeBox = true // 票据类型选择框初始为折叠状态

            // 票据类型框中票据
            $scope.billTypeSet = managementConfig.billTypeSet
            $scope.profileTypeObj.table = managementConfig.allTable[$scope.billType]
            // 票据对应查询参数invoiceTypeList
            $scope.billParamSet = managementConfig.billParamSet
        }
        initSpilitBillType()
        // 点击票据类型
        $scope.billTypeChange = function billTypeChange(type) {
            $scope.billType = type
            // $scope.batchDropdownConfig.options[5].isHide = type == 1 ? false : true
            $scope.profileType = $scope.billParamSet[type].profileType
            $scope.billTypeTitle = $scope.billTypeSet.filter((item) => {
                return item.type == type
            })
            $scope.profileTypeObj.table = managementConfig.allTable[$scope.billType]
            // $scope.orderMap = {}
            $scope.param.param.invoiceTypeList = $scope.billParamSet[type].invoiceTypeList
            $scope.handleExportField()
            $scope.queryTaxInfo()
        }
        // 票种导出字段设置
        $scope.handleExportField = () => {
            const { mainInfo } = $scope.exportConfig
            let comparisonStatusIndex = mainInfo.findIndex((item) => item.fieldName == '状态比对')
            $scope.exportConfig.mainInfo.splice(comparisonStatusIndex, 1)
        }
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            $scope.queryTaxInfo()
        }
        $scope.param.param.invoiceTypeList = $scope.billParamSet[1].invoiceTypeList

        $scope.reset = function reset() {
            $scope.param.param = {
                createTimeStart: utils.getMonthFirstLast().firstDate1,
                createTimeEnd: utils.getNowDate().now_Date,
                invoiceTypeList: $scope.param.param.invoiceTypeList,
                invoiceType: '',
                invoiceCode: '',
                invoiceDateStart: '',
                invoiceDateEnd: '',
                collectionDateStart: '',
                collectionDateEnd: '',
                // verifyStatus: '',
                taxRate: '',
                adValoremTotalStart: '',
                createUser: '',
                invoiceStatus: '',
                invoiceSource: '',
                saleName: '',
                saleCreditCode: '',
                userName: '',
                destination: '',
                departure: '',
                deductionFlag: '',
                passengerFlag: '',
                claimNumber: '',
                collectionStatus: '',
                turnOutType: '',
                usagePage: 3,
                zcssq: '',
                dkssq: '',
                projectName: '',
                projectCode: '',
                transferOutSign: '',
                transferAmount: '',
                orgIdList: $scope.orgIdListArr,
                sourceAppId: '',
            }
            $scope.belleRegionCityList = []
            // 重置默认机构勾选
            getUserOrgList()
            $scope.$broadcast('selectedOrgList', $scope.selectedOrgList)
            $scope.$broadcast('billTypeList', $scope.billTypeList)
            // $scope.billTypeSearch($scope.dictData.ivat_inv_add_type)
        }
        $scope.reset()
        $scope.dateConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
        }

        // 表格下拉框配置
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    const params = {
                        ...$scope.param,
                    }
                    // httpRequest.post_selectPageBill(params).then((res) => {
                    $uibModal.open({
                        template: modalList,
                        controller: 'CollectionModalListCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                        resolve: {
                            items1() {
                                const data = {
                                    modalListData: $scope.collectList && $scope.collectList.map((item) => item.invoiceId),
                                    currentInvoicId: item.invoiceId,
                                    total: $scope.totalItems,
                                    fromWhere: 2, // 发票管理
                                    param: $scope.param.param,
                                    originalPageNum: $scope.param.pageNum,
                                    pageSize: $scope.param.pageSize,
                                }
                                return data
                            },
                        },
                    })
                    // })
                },
                showWhile(item, hasPermit) {
                    item.detailHasPermit = $scope.hasPermitHandle(item.orgId, 'management_detail')
                    return $scope.hasPermitHandle(item.orgId, 'management_detail')
                },
            },
            {
                label: '收票',
                handler(item) {
                    $scope.receive([item])
                },
                showWhile(item, hasPermit) {
                    item.invoiceHasPermit = $scope.hasPermitHandle(item.orgId, 'receive_invoice')
                    return $scope.hasPermitHandle(item.orgId, 'receive_invoice') && (item.collectionStatus == 0 || item.collectionStatus == 2)
                },
            },
            {
                label: '回退',
                handler(item) {
                    $scope.backInvoice([item])
                },
                showWhile(item, hasPermit) {
                    item.regressionHasPermit = $scope.hasPermitHandle(item.orgId, 'collection_regression')
                    return $scope.hasPermitHandle(item.orgId, 'collection_regression') && item.reimbursementStatus != 1 && item.reimbursementStatus != 2
                },
            },
            {
                label: '取消收票',
                handler(item) {
                    $scope.cancelReceive([item])
                },
                showWhile(item, hasPermit) {
                    item.cancelHasPermit = $scope.hasPermitHandle(item.orgId, 'receive_invoice')
                    return $scope.hasPermitHandle(item.orgId, 'receive_invoice') && item.collectionStatus == 1
                },
            },
            {
                label: '转出',
                handler(item) {
                    $scope.rollOut([item])
                },
                showWhile(item, hasPermit) {
                    item.managementHasPermit = $scope.hasPermitHandle(item.orgId, 'rollout_management')
                    return $scope.hasPermitHandle(item.orgId, 'rollout_management') && item.deductionFlag && item.deductionFlag !== '0'
                },
            },
            {
                label: '取消转出',
                handler(item) {
                    $scope.cancelRollOut([item])
                },
                showWhile(item, hasPermit) {
                    item.rolloutHasPermit = $scope.hasPermitHandle(item.orgId, 'cancel_rollout')
                    return $scope.hasPermitHandle(item.orgId, 'cancel_rollout') && item.deductionFlag && item.turnOutType && item.deductionFlag !== '0'
                },
            },
            {
                label: '下载影像',
                handler(item) {
                    // window.open(`${host.etcloudIvatApp}manage/ivatBill/downloadInvoiceSingle?accessToken=${localStorage.id_token}&invoiceId=${item.invoiceId}`)
                    utils.post_downLoad(
                        {
                            invoiceId: item.invoiceId,
                        },
                        `${host.etcloudIvatApp}manage/ivatBill/downloadInvoiceSingle?accessToken=${localStorage.id_token}`
                    )
                },
                showWhile(item, hasPermit) {
                    return $scope.billType == 1 || $scope.billType == 10 || $scope.billType == 11 || item.imageKey
                },
            },
        ]

        function handleParam() {
            if ($scope.billType == 1) {
                if ($scope.param.param.invoiceType || $scope.param.param.invoiceType === 0) {
                    $scope.param.param.invoiceTypeList = []
                    $scope.param.param.invoiceTypeList.push($scope.param.param.invoiceType)
                } else {
                    $scope.param.param.invoiceTypeList = $scope.billParamSet[1].invoiceTypeList
                    $scope.param.param.invoiceType = ''
                }
                $scope.param.param.userName = '' // 去掉非增值税的字段
                $scope.param.param.destination = ''
                $scope.param.param.departure = ''
            }
            if ($scope.billType != 1 && $scope.billType != 14) {
                $scope.param.param.saleName = '' // 去掉增值税发票的字段
                $scope.param.param.saleCreditCode = ''
                $scope.param.param.invoiceStatus = ''
                $scope.param.param.invoiceType = ''
                $scope.param.param.invoiceTypeList = $scope.billParamSet[$scope.billType].invoiceTypeList
            }
        }
        $scope.currentOvatAmt = {}
        $scope.selectedRows = []
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedRows)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedRows.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            httpRequest.post_getIvatBillStatics($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 查询列表
        $scope.queryTaxInfo = function () {
            handleParam()
            httpRequest.post_selectPageBill($scope.param).then((res) => {
                $scope.collectList = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
                // 查询之后清空已经选择的数据
                $scope.selectedRows = []
                $scope.menuPermissions($scope.collectList)
            })
            getData()
        }
        // 获取当前登陆用户的菜单权限
        $scope.menuPermissions = function (collectList) {
            let allOrgIdListArr = []
            angular.forEach(collectList, (item, index) => {
                allOrgIdListArr.push(item.orgId)
            })
            const newAllOrgIdListArr = (arr) => [...new Set(arr)]
            httpRequest.post_getFunctionListByUserAndOrgIds(newAllOrgIdListArr(allOrgIdListArr)).then((res) => {
                $scope.allMenuPermissions = res.data.value
            })
        }
        // 权限控制
        $scope.hasPermitHandle = function (dataOrgId, hasPermit) {
            if (!$scope.allMenuPermissions || $scope.allMenuPermissions.length == 0) {
                return
            }
            // 默认 false
            $scope.hasPermitFlag = false
            // 对应菜单数据权限
            $scope.CorrMenuPermiss = $scope.allMenuPermissions.filter((item) => {
                return item.orgId == dataOrgId
            })
            functionListChild($scope.CorrMenuPermiss[0].functionList, currentRoutAddress, hasPermit, (item, currentRout, hasPermit) => {
                if (item.url == currentRout) {
                    // console.log('存在路由')
                    return true
                } else if (item.functionCode == hasPermit) {
                    // console.log('存在对应权限')
                    $scope.hasPermitFlag = true
                    return false
                }
                return false
            })
            return $scope.hasPermitFlag
        }
        // 校验是否有权限
        let functionListChild = function (functionList, currentRout, hasPermit, cb) {
            for (const i in functionList) {
                let flat = cb(functionList[i], currentRout, hasPermit)
                if (functionList[i].childFuncList && flat) {
                    functionListChild(functionList[i].childFuncList, currentRout, hasPermit, cb)
                }
            }
        }
        // 导出
        $scope.exportInvoice = function () {
            handleParam()
            // const reqObj = $.extend({
            //     accessToken: localStorage.id_token,
            // }, $scope.param.param)
            // httpRequest.get_exportIvatBillToExcel(reqObj)
            const reqObj = $.extend({}, $scope.param.param, {
                idList: $scope.selectedRows.map((x) => x.invoiceId),
            })
            let _url = `${host.etcloudIvatApp}manage/ivatBill/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.param.orderMap) {
                reqObj.sortField = i + ':' + $scope.param.orderMap[i]
            }
            /*let downloadUrl = 'manage/ivatBill/exportToExcel?'
            Object.keys(reqObj).forEach((key) => {
                downloadUrl += `${key}=${encodeURI(reqObj[key])}&`
            })
            window.open(`${host.etcloudIvatApp}${downloadUrl}&accessToken=${$scope.idToken}`)*/
            httpRequest.post_billExportToExcel(reqObj).then((res) => {
                logger.logSuccess(res.data.message)
            })
            // utils.post_downLoad(reqObj, _url)
        }
        // 批量收票
        $scope.receive = function receive(list) {
            const selectedRows = list || $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择收票行')
            } else if (!currentOrgAuthority(selectedRows, 'receive_invoice', '收票')) {
                return
            }
            let showCollectTip = true
            for (const key in selectedRows) {
                if (selectedRows[key].collectionStatus == 1) return logger.logError('已选择数据中存在不可收票数据！')
                if (selectedRows[key].billSource != 0) showCollectTip = false
            }
            const invoiceIdList = []
            selectedRows.forEach((row) => {
                invoiceIdList.push(row.invoiceId)
            })
            /*if (showCollectTip) {
                $uibModal.open({
                    templateUrl: 'receive.html',
                    openedClass: 'mod-modal mod-modal-md',
                    controller: ['$scope', '$uibModalInstance', 'httpRequest', 'receiveParam', ($scope, $uibModalInstance, httpRequest, receiveParam) => {
                        $scope.rzflId = ''
                        $scope.entryList = receiveParam.entryList
                        $scope.showCollectTip = receiveParam.showCollectTip
                        $scope.ok = function ok() {
                            httpRequest.post_batchReceiptBill({
                                invoiceIdList: receiveParam.invoiceIdList,
                                receliptExpenseBill: Boolean(+$scope.receliptExpenseBill),
                                rzflId: $scope.rzflId
                            }).then((res) => {
                                if (!res.data.value.length) {
                                    logger.logSuccess('收票成功！')
                                    $uibModalInstance.close()
                                } else {
                                    logger.logError('收票失败！')
                                }
                            })
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.dismiss()
                        }
                    }],
                    animation: true,
                    resolve: {
                        receiveParam() {
                            return {
                                invoiceIdList,
                                entryList: $scope.entryList,
                                showCollectTip
                            }
                        }
                    },
                }).result.then(() => {
                    $scope.queryTaxInfo()
                })
            } else {*/
            sweetalert.confirm('确认收票', '确认已收到票据？').then(() => {
                httpRequest
                    .post_batchReceiptBill({
                        invoiceIdList,
                        receliptExpenseBill: false,
                    })
                    .then((res) => {
                        if (!res.data.value.length) {
                            logger.logSuccess('收票成功！')
                            $scope.queryTaxInfo()
                        } else {
                            logger.logError('收票失败！')
                        }
                    })
            })
            //}
        }

        $scope.rollOut = function rollOut(list) {
            const selectedRows = list || $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择转出行')
            } else if (!currentOrgAuthority(selectedRows, 'rollout_management', '转出')) {
                return
            }
            let showConfirm = true
            for (const key in selectedRows) {
                if (!selectedRows[key].deductionFlag || selectedRows[key].deductionFlag === '0') return logger.logError('已选择数据中存在不可转出数据！')
                if (selectedRows[key].billSource != 0) showConfirm = false
            }
            // const invoiceIdList = []
            // selectedRows.forEach((row) => {
            //     invoiceIdList.push(row.invoiceId)
            // })
            if (showConfirm) {
                sweetalert.confirm('转出提醒', '系统已根据报销单项目内容划分进项转出，请确定转出或修改转出内容？').then(() => {
                    $scope.rollOutModuleHandle(selectedRows, showConfirm)
                })
            } else {
                $scope.rollOutModuleHandle(selectedRows)
            }
        }

        $scope.cancelRollOut = function cancelRollOut(list) {
            const selectedRows = list || $scope.selectedRows
            let showConfirm = true
            if (selectedRows.length === 0) {
                return logger.logError('请选择取消转出行')
            } else if (!currentOrgAuthority(selectedRows, 'cancel_rollout', '取消转出')) {
                return
            }
            const invoiceIdList = []
            selectedRows.forEach((row) => {
                invoiceIdList.push(row.invoiceId)
            })
            for (const key in selectedRows) {
                if (!selectedRows[key].deductionFlag || selectedRows[key].deductionFlag === '0' || !selectedRows[key].turnOutType) return logger.logError('已选择数据中存在不可转出数据！')
                if (selectedRows[key].billSource != 0) showConfirm = false
            }
            if (showConfirm) {
                sweetalert.confirm('取消转出', '系统已根据报销单项目内容划分进项转出，请确定是否取消转出？').then(() => {
                    httpRequest.post_batchCalTurnoutBill(invoiceIdList).then((res) => {
                        if (!res.data.value.length) {
                            logger.logSuccess('成功取消转出！')
                            $scope.queryTaxInfo()
                        } else {
                            logger.logError('取消转出失败！')
                        }
                    })
                })
            } else {
                httpRequest.post_batchCalTurnoutBill(invoiceIdList).then((res) => {
                    if (!res.data.value.length) {
                        logger.logSuccess('成功取消转出！')
                        $scope.queryTaxInfo()
                    } else {
                        logger.logError('取消转出失败！')
                    }
                })
            }
        }
        //回退
        $scope.backInvoice = function backInvoice(list) {
            const selectedRows = list || $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择回退行')
            } else if (!currentOrgAuthority(selectedRows, 'collection_regression', '回退')) {
                return
            }

            let flag = selectedRows.some((ele) => {
                return ele.reimbursementStatus && (ele.reimbursementStatus == '1' || ele.reimbursementStatus == '2')
            })
            if (flag) return logger.logError('回退失败，报销中/已报销的票据不允许回退！')
            // for (const key in selectedRows) {
            //     if (selectedRows[key].billSource != 1) {
            //         return logger.logError('批量回退失败，报销或已抵扣的票据不允许回退！')
            //     }
            // }
            const invoiceIdList = []
            selectedRows.forEach((row) => {
                invoiceIdList.push(row.invoiceId)
            })
            sweetalert.confirm('确认回退', '确认回退票据？').then(() => {
                httpRequest.post_batchRegressionBill(invoiceIdList).then((res) => {
                    if (res.data.success) {
                        logger.logSuccess('回退成功！')
                        $scope.queryTaxInfo()
                    } else {
                        logger.logError('回退失败！')
                    }
                })
            })
        }

        // 取消收票
        $scope.cancelReceive = function cancelReceive(list) {
            const selectedRows = list || $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择取消收票行')
            } else if (!currentOrgAuthority(selectedRows, 'receive_invoice', '取消收票')) {
                return
            }
            // let showCollectTip = selectedRows.length === 1 && selectedRows[0].billSource === '0'
            let showCollectTip = true
            for (const key in selectedRows) {
                if (selectedRows[key].billSource != 0) showCollectTip = false
            }
            const invoiceIdList = []
            selectedRows.forEach((row) => {
                invoiceIdList.push(row.invoiceId)
            })
            if (showCollectTip) {
                $uibModal
                    .open({
                        templateUrl: 'cancelReceive.html',
                        openedClass: 'mod-modal mod-modal-md',
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'httpRequest',
                            'receiveParam',
                            ($scope, $uibModalInstance, httpRequest, receiveParam) => {
                                $scope.ok = function ok() {
                                    httpRequest
                                        .post_batchCalReceiptBill({
                                            invoiceIdList: receiveParam,
                                            receliptExpenseBill: Boolean(+$scope.receliptExpenseBill),
                                        })
                                        .then((res) => {
                                            if (!res.data.value.length) {
                                                logger.logSuccess('取消收票成功！')
                                            } else {
                                                if (selectedRows.length === 1) {
                                                    logger.logError(res.data.value[0].errorMsg)
                                                }
                                                if (selectedRows.length > res.data.value.length) {
                                                    logger.logSuccess('部分票据取消收票成功！')
                                                }

                                                if (selectedRows.length === res.data.value.length && res.data.value.length > 1) {
                                                    logger.logError('当前选中票据无可以取消收票的票据')
                                                }
                                            }
                                            $uibModalInstance.close()
                                        })
                                }
                                $scope.cancel = function cancel() {
                                    $uibModalInstance.dismiss()
                                }
                            },
                        ],
                        animation: true,
                        resolve: {
                            receiveParam() {
                                return invoiceIdList
                            },
                        },
                    })
                    .result.then(() => {
                        $scope.queryTaxInfo()
                    })
            } else {
                sweetalert.confirm('取消收票确认', '确认取消收票？').then(() => {
                    httpRequest
                        .post_batchCalReceiptBill({
                            invoiceIdList,
                            receliptExpenseBill: false,
                        })
                        .then((res) => {
                            if (!res.data.value.length) {
                                logger.logSuccess('取消收票成功！')
                            } else {
                                if (selectedRows.length === 1) {
                                    logger.logError(res.data.value[0].errorMsg)
                                }
                                if (selectedRows.length > res.data.value.length) {
                                    logger.logSuccess('部分票据取消收票成功！')
                                }

                                if (selectedRows.length === res.data.value.length && res.data.value.length > 1) {
                                    logger.logError('当前选中票据无可以取消收票的票据')
                                }
                            }
                            $scope.queryTaxInfo()
                        })
                })
            }
        }

        $scope.rollOutModuleHandle = function rollOutModuleHandle(list, isReimburse) {
            $uibModal
                .open({
                    templateUrl: 'rollOut.html',
                    openedClass: 'mod-modal mod-modal-md roll-out-mod',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        'reqVal',
                        '$filter',
                        'logger',
                        'resultTipService',
                        ($scope, $uibModalInstance, httpRequest, reqVal, $filter, logger, resultTipService) => {
                            const invoiceIdList = []
                            $scope.isReimburse = reqVal.isReimburse
                            $scope.ivatRuleList = reqVal.ivatRuleList
                            $scope.title = '进项转出'
                            $scope.params = {
                                adValoremTotal: 0,
                                totalTaxamt: 0,
                            }
                            if (reqVal.list.length > 1) {
                                $scope.title = '批量转出'
                                $scope.isBatch = true
                                reqVal.list.forEach((item) => {
                                    $scope.params.adValoremTotal += +item.adValoremTotal
                                    $scope.params.totalTaxamt += +item.totalTaxamt
                                    invoiceIdList.push(item.invoiceId)
                                })
                                $scope.params.turnoutWay = '1'
                                $scope.params.turnoutTaxamt = Number($scope.params.totalTaxamt).toFixed(2)
                                $scope.params.turnoutDate = $filter('date')(new Date(), 'yyyyMM')
                                $scope.params.turnoutType = $scope.ivatRuleList[0].ruleConfId
                            } else {
                                $scope.params = reqVal.list[0]
                                $scope.params.turnoutWay = '1'
                                invoiceIdList.push($scope.params.invoiceId)
                                $scope.params.turnoutDate = reqVal.list[0].zcssq
                                $scope.params.turnoutType = reqVal.list[0].turnOutType
                                httpRequest.get_turnoutAccountDetail(reqVal.list[0].invoiceId).then((res) => {
                                    if (res.data.success && res.data.value) {
                                        const { deductionPeriod, turnoutWay, turnoutRate, turnoutAmt, turnoutRemark, turnoutTaxamt } = res.data.value
                                        $scope.params.dkssq = deductionPeriod
                                        $scope.params.turnoutWay = turnoutWay || '1'
                                        $scope.params.turnoutRate = turnoutRate
                                        $scope.params.turnoutAmt = turnoutAmt
                                        $scope.params.turnoutRemark = turnoutRemark
                                        $scope.params.turnoutTaxamt = turnoutTaxamt

                                        if ($scope.isReimburse) $scope.params.turnoutTaxamt = Number($scope.params.totalTaxamt).toFixed(2)
                                    }
                                })
                            }
                            $scope.dateConfig = {
                                format: 'yyyymm',
                                startView: 'year',
                                minView: 'year',
                                endDate: new Date(),
                            }
                            if ($scope.isReimburse) $scope.params.turnoutTaxamt = Number($scope.params.totalTaxamt).toFixed(2)
                            const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
                            $scope.rateChange = function () {
                                if ($scope.params.turnoutRate <= 0 || $scope.params.turnoutRate > 1 || !reg.test($scope.params.turnoutRate)) {
                                    $scope.params.turnoutRate = ''
                                    return
                                }
                                $scope.params.turnoutTaxamt = (+$scope.params.turnoutRate * +$scope.params.totalTaxamt).toFixed(2)
                                $scope.params.turnoutRate = Number($scope.params.turnoutRate).toFixed(2)
                            }
                            $scope.taxamtChange = function () {
                                if ($scope.params.turnoutTaxamt <= 0 || $scope.params.turnoutTaxamt > $scope.params.totalTaxamt || !reg.test($scope.params.turnoutTaxamt)) {
                                    $scope.params.turnoutTaxamt = ''
                                    return
                                }
                                $scope.params.turnoutTaxamt = Number($scope.params.turnoutTaxamt).toFixed(2)
                            }
                            $scope.amtChange = function () {
                                if ($scope.params.turnoutAmt <= 0 || $scope.params.turnoutAmt > $scope.params.adValoremTotal || !reg.test($scope.params.turnoutAmt)) {
                                    $scope.params.turnoutAmt = ''
                                    return
                                }
                                $scope.params.turnoutTaxamt = ((+$scope.params.turnoutAmt / +$scope.params.adValoremTotal) * +$scope.params.totalTaxamt).toFixed(2)
                                $scope.params.turnoutAmt = Number($scope.params.turnoutAmt).toFixed(2)
                            }
                            $scope.ok = function ok() {
                                if ($scope.params.turnoutWay == 2 && !$scope.params.turnoutAmt) return logger.logError('转出金额不能为空')
                                if ($scope.params.turnoutWay == 3 && !$scope.params.turnoutRate) return logger.logError('转出比例不能为空')
                                if (!$scope.params.turnoutTaxamt) return logger.logError('转出税额不能为空')
                                utils.loading('票据正在转出')
                                httpRequest
                                    .post_batchTurnoutBill({
                                        invoiceIdList,
                                        settingDTO: $scope.params,
                                    })
                                    .then((res) => {
                                        utils.loaded()
                                        if (res.data.value.length) {
                                            const params = {
                                                sourceCount: invoiceIdList.length,
                                                errorCount: res.data.value.length,
                                                list: res.data.value,
                                                title: '转出',
                                            }
                                            resultTipService.openErrorModal(params)
                                        } else {
                                            logger.logSuccess(`转出成功${invoiceIdList.length}张票据`)
                                        }
                                        $uibModalInstance.close()
                                    })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    animation: true,
                    resolve: {
                        reqVal() {
                            return {
                                list,
                                ivatRuleList: $scope.ivatRuleList,
                                isReimburse,
                            }
                        },
                    },
                })
                .result.then(() => {
                    $scope.queryTaxInfo()
                })
        }
        // 下载源文件
        $scope.downloadSourceFile = () => {
            const selectedRows = $scope.selectedRows
            if (selectedRows.length === 0) {
                return logger.logError('请选择要下载的数据行')
            }
            let invoiceIds = []
            try {
                selectedRows.forEach((item) => {
                    if (item.invoiceType != '51' && item.invoiceType != '08' && item.invoiceType != '14' && item.invoiceType != '111' && item.invoiceType != '61' && item.invoiceType != '62') {
                        throw new Error('所选择发票数据包含非电子票，请重新筛选选择!')
                    }
                    if (item.billSource != '1' || item.sourceSystem != '4') {
                        throw new Error('所选发票<录入方式>或<来源系统>不满足下载条件，请选择E税云上传的发票!')
                    }
                    console.log(item.createTime)
                    if (checkHistoricalDataTime('2022-04-01') > checkHistoricalDataTime(item.createTime)) {
                        throw new Error('历史数据未上传源文件，不支持下载源文件。')
                    }
                    invoiceIds.push(item.invoiceId)
                })
            } catch (e) {
                return logger.logError(e.message)
            }
            httpRequest.get_downloadETaxInvoiceSourceFile({
                invoiceIds: invoiceIds.join(','),
                accessToken: localStorage.getItem('id_token'),
            })
        }
        // 检查历史数据时间
        function checkHistoricalDataTime(time) {
            let timeStamp
            let date = new Date(time)
            timeStamp = date.getTime()
            return timeStamp
        }
        // 当前机构批量操作的权限
        function currentOrgAuthority(selectedRows, hasPermit, tipsMsg) {
            try {
                angular.forEach(selectedRows, (item, index) => {
                    switch (true) {
                        // 收票
                        case hasPermit == 'receive_invoice':
                            if (!item.invoiceHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        // 回退
                        case hasPermit == 'collection_regression':
                            console.log(item)

                            if (!item.regressionHasPermit || !(item.reimbursementStatus && item.reimbursementStatus != 1 && item.reimbursementStatus != 2)) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        // 转出
                        case hasPermit == 'rollout_management':
                            if (!item.managementHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        // 取消收票
                        case hasPermit == 'receive_invoice':
                            if (!item.cancelHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                        // 取消转出
                        case hasPermit == 'cancel_rollout':
                            if (!item.rolloutHasPermit) {
                                logger.logError(`第${index + 1}条数据没有${tipsMsg}权限,请检查！`)
                                throw new Error(true)
                            }
                            break
                    }
                })
            } catch (e) {
                return false
            }
            return true
        }
        $scope.updateTheEntryMonth = function () {
            if (!$scope.selectedRows.length) return logger.logError('请选择数据')
            let isPort = $scope.selectedRows.some((x) => x.billSource == '2')
            if (isPort) return logger.logError('更新入账月份仅支持录入方式为非:“接口”,请检查')
            let invoiceIdList = $scope.selectedRows.map((x) => x.invoiceId)
            $uibModal
                .open({
                    template: updateMonthModal,
                    backdrop: 'static',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'httpRequest',
                        '$filter',
                        'logger',
                        'modalData',
                        ($scope, $uibModalInstance, httpRequest, $filter, logger, modalData) => {
                            const { invoiceIdList } = modalData
                            $scope.datePickerConfig = {
                                endDate: new Date(),
                                format: 'yyyymm',
                                startView: 'year',
                                minView: 'year',
                            }
                            $scope.param = {
                                invoiceIdList,
                                paymentMonth: '',
                            }
                            // 确定
                            $scope.ok = function ok() {
                                if (!$scope.param.paymentMonth) return logger.logError('请选择入账月份')
                                httpRequest.post_batchUpdateBillPaymentMonth($scope.param).then((res) => {
                                    const { failNum, successNum, totalNum } = res.data.value
                                    logger.logSuccess(`成功${successNum}条，失败${failNum}条。`)
                                    $uibModalInstance.close()
                                })
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                        },
                    ],
                    openedClass: 'mod-modal mod-modal-lg mod-modal-big',
                    resolve: {
                        modalData() {
                            return { invoiceIdList }
                        },
                    },
                })
                .result.then((data) => {
                    $scope.queryTaxInfo()
                })
        }
    }
}

managementListCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'sweetalert', 'logger', 'initSortService', 'exportSettingService', 'getOvatAmtService']
export default managementListCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/managementListCtrl.js